var render = function render(){var _vm=this,_c=_vm._self._c;return _c('m-pageframe',{attrs:{"title":"Accessibility"}},[_c('accessibility-user-feedback-form')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }